export default __webpack_public_path__ + "static/media/icon 10.c72f0dab.svg";